import { Route, Routes } from 'react-router-dom'
import Company from '..'
import BrandCustomization from '../brandCustomization'
import { CompanyContextProvider } from '../context'

const CompanysRoutes = () => {
  return (
    <CompanyContextProvider>
      <Routes>
        <Route path="/" element={<Company />} />
        <Route path=":id" element={<BrandCustomization />} />
      </Routes>
    </CompanyContextProvider>
  )
}

export default CompanysRoutes
